import React, { Component } from "react"
import { graphql,Link } from "gatsby"
import CalendarList from "../images/calendar-list-active.svg"
import CalendarListClose from "../images/calendar-list-close.svg"
import CalendarIcon from "../images/calendar-open.svg"
import CalendarIconClose from "../images/calendar-close.svg"
import $ from "jquery"

class EventsSlider extends Component {

  constructor() {
    var today = new Date(),
    date = today.getFullYear() +''+(today.getMonth() + 1);
    super();
    this.state = {
      currentDateTime: date,
      setSlide : false
    }
  }

  componentDidMount() {
    $('.calendar-view-1').click(function(){
      $('.uk-slider-container').show();
      $('.events-calendar').hide();
      $('.calendar-prev-next').css('visibility','visible')
      $('.open-icon').show()
      $('.close-icon').hide()
    })


    $('.calendar-view-2').click(function(){
      $('.uk-slider-container').hide();
      $('.events-calendar').show();
      $('.calendar-prev-next').css('visibility','hidden');
      $('.open-icon').hide();
      $('.close-icon').show();
      $('.events-calendar .rbc-toolbar .rbc-btn-group button:nth-child(3)').click();
      $('.events-calendar .rbc-toolbar .rbc-btn-group button:nth-child(4)').click();
    })

    var mounthText = $('.rbc-toolbar .rbc-toolbar-label').text()
    $('.events-calendar .rbc-toolbar .rbc-btn-group:first-of-type button').text('')
    $('.events-calendar .rbc-toolbar .rbc-btn-group:first-of-type').prepend('<span class="mounth-label">'+mounthText+'</span>');
    $('.mounth-label').text(mounthText)

    $('.events-calendar .rbc-toolbar .rbc-btn-group:first-of-type button').click(function(){
      setTimeout(function(){
        mounthText = $('.rbc-toolbar .rbc-toolbar-label').text()

        $('.mounth-label').text(mounthText);
      },100)
    })
  }

  render(props) {
    var moment = require('moment'); // require
    const currentEvents = this.props.events
    const landingPageRel = this.props.landingPages
    var date = '';
    var newArrEvents = []

    return (

            currentEvents.length > 0 ? (
              <>
              <div className="calendar-view uk-flex-middle">
                <div className="calendar-prev-next">
                  <span className="date-year">January 2021</span>
                  <a className="uk-position-center-left uk-position-small uk-slidenav" href="#" title="calendar-icon-previous" aria-label="calendar-previous" data-uk-slidenav-previous uk-slider-item="previous"></a>
                  <a className="uk-position-center-right uk-position-small uk-slidenav" href="#" title="calendar-icon-next" aria-label="calendar-icon" data-uk-slidenav-next uk-slider-item="next"></a>
                </div>
                <div className="button-wrp">
                  <a className="calendar-view-1" title="calendar-icon" aria-label="calendar-icon" href="#">
                    <img className="open-icon" src={CalendarList} alt="open icon 1"/>
                    <img className="close-icon" src={CalendarListClose} alt="close icon 1"/>
                  </a>
                  <a className="calendar-view-2" href="#" title="calendar-icon" aria-label="calendar-icon">
                    <img className="open-icon" src={CalendarIconClose} alt="open icon 2"/>
                    <img className="close-icon" src={CalendarIcon} alt="close icon 2" />
                  </a>
                </div>
              </div>

              <div className="uk-slider-container">
                <ul className="uk-slider-items uk-grid uk-child-width-1-1@m" data-uk-grid>
                  {
                    currentEvents && currentEvents.map((news,key) => (
                        moment(news.node.field_start_date).format("YYYY-MM") !== date ? (
                            date = moment(news.node.field_start_date).format("YYYY-MM"),
                            newArrEvents[date.replace('-','')] = [],
                          newArrEvents[date.replace('-','')][key] = news,
                          null
                        ) : (
                          newArrEvents[date.replace('-','')][key] = news,
                          null
                        )
                    )),


                    newArrEvents.map((eventArr,ekey) => (
                      <li key={"slider"+ekey}>
                        <div className="uk-grid-small uk-flex uk-child-width-1-2@m uk-child-width-1-4@l uk-grid-match" data-uk-grid>
                          {eventArr && eventArr.map((event,key) => (
                            <div key={"event"+key}>
                              <span className="current-date uk-hidden">{moment(event.node.field_start_date).format("MMMM YYYY")}</span>
                              {this.state.currentDateTime <= moment(event.node.field_start_date).format("YYYYMM") && !this.state.setSlide ? (
                                <span className="current-slide uk-hidden">{ekey}</span>
                              ) : (
                                null
                              )}
                              <div className=" uk-card uk-flex uk-flex-column events-cards">
                                <div className="uk-card-header">
                                  {moment(event.node.field_start_date).format("YYYY-MM-DD")}
                                </div>
                                <div className="uk-card-body">
                                  <Link to={event.node.path.alias}><h2 className="h3">{event.node.title}</h2></Link>
                                </div>
                                <div className="uk-card-footer">
                                  {event.field_virtual_event === true ? (
                                    <div className="location">Virtual Event</div>
                                  ) : (
                                    event.node.field_address_line_2 != null && event.node.field_address_line_1 != null ? (
                                      <React.Fragment>
                                        <div className="time">{moment(event.node.field_start_date.split("-04:00")[0]).format("hh:mm A")} - {moment(event.node.field_end_date.split("-04:00")[0]).format("hh:mm A")}</div>
                                        <div className="location">{event.node.field_address_line_1 + ", " + event.node.field_address_line_2}</div>
                                      </React.Fragment>
                                    ) : (
                                      event.node.field_address_line_1 != null ? (
                                        <React.Fragment>
                                          <div className="time">{moment(event.node.field_start_date.split("-04:00")[0]).format("hh:mm A")} - {moment(event.node.field_end_date.split("-04:00")[0]).format("hh:mm A")}</div>
                                          <div className="location">{event.node.field_address_line_1}</div>
                                        </React.Fragment>
                                      ) : (
                                        null
                                      )
                                    )
                                  )}

                                  {
                                    landingPageRel !== undefined ? (

                                      event.node.relationships.group_content__departments_group_node_event && event.node.relationships.group_content__departments_group_node_event.length > 0 ? (
                                        event.node.relationships.group_content__departments_group_node_event.map((group,key) => (
                                          landingPageRel[group.relationships.gid.drupal_internal__id] !== undefined ? (
                                            <Link className="landing-page-link" key={"grouplink"+key} to={landingPageRel[group.relationships.gid.drupal_internal__id]['path'] + '/events'}>{landingPageRel[group.relationships.gid.drupal_internal__id]['title']}<br /></Link>
                                          ) : (
                                            <Link className="landing-page-link"  key={"grouplink"+key} to="/events">County Events</Link>
                                          )
                                        ))
                                      ) : (
                                        <Link className="landing-page-link" to="/events">County Events</Link>
                                      )
                                    ) : (
                                      null
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          ))}

                        </div>
                      </li>
                    ))
                  }

                </ul>
              </div>
              </>
            ) : (
              null
            )

      )
  }
}

export default EventsSlider
